import React from 'react';
import { Button } from './ui/Button';
import { Heart } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function OfferSection() {
  return <section id="offer-section" className="py-24 bg-brand-cream relative" data-id="element-82">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-83">
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 lg:p-16 shadow-lg border border-brand-sage/50 text-center relative overflow-hidden" data-id="element-84">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-brand-rose/20 rounded-br-full -z-10" data-id="element-85"></div>
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-brand-sage/30 rounded-tl-full -z-10" data-id="element-86"></div>

          <Heart className="w-12 h-12 text-brand-gold mx-auto mb-6" fill="#C5A55A" fillOpacity={0.2} data-id="element-87" />

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-88">
            Reconnecting with your grandchildren shouldn't be a gamble.
          </h2>

          <p className="text-lg md:text-xl text-brand-body mb-12 max-w-2xl mx-auto" data-id="element-89">
            Get the scripts, the framework, and the peace of mind you need to
            start rebuilding tonight.
          </p>

          <div className="bg-brand-sage/30 rounded-2xl p-8 max-w-md mx-auto mb-10 border border-brand-sage" data-id="element-90">
            <h3 className="font-heading font-bold text-2xl mb-2" data-id="element-91">
              The Reconciliation Roadmap & Peace Bundle
            </h3>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-92">
            <Button href="https://www.sachaliving.com/cart/48568460050660:1" className="w-full md:w-auto px-12 py-5 text-xl shadow-lg shadow-brand-gold/20" onClick={() => trackAddToCart()} data-id="element-93">
              Get Instant Access to the Roadmap
            </Button>
            <div className="flex items-center gap-2 mt-2" data-id="element-94">
              <span className="text-brand-body/60 line-through text-base" data-id="element-95">
                $27
              </span>
              <span className="bg-brand-gold/15 text-brand-gold font-bold text-lg px-3 py-1 rounded-full border border-brand-gold/30" data-id="element-96">
                Only $6.39 today
              </span>
            </div>
          </div>

          <p className="mt-6 text-sm text-brand-body/70" data-id="element-97">
            Your digital download will be delivered immediately to your email.
          </p>
        </div>
      </div>
    </section>;
}